// React is required by the project's legacy JSX lint rule.

import React, { useState } from 'react';
import { useBiometric } from '../hooks/useBiometric';

/**
 * BiometricLogin Component
 * Displays a biometric login button when biometric authentication is available and enabled
 * Handles fingerprint/face recognition login
 */
export default function BiometricLogin({ onBiometricLogin, disabled = false }) {
  const {
    biometricAvailable,
    biometricEnabled,
    loading,
    error,
    authenticateWithBiometric,
    getBiometricTypeName
  } = useBiometric();

  const [localError, setLocalError] = useState(null);

  const handleBiometricLogin = async () => {
    setLocalError(null);
    const loginPayload = await authenticateWithBiometric();

    if (loginPayload) {
      onBiometricLogin(loginPayload);
    } else {
      setLocalError('Biometrische inloggen mislukt');
    }
  };

  // Don't show button if biometric not available or not enabled
  if (!biometricAvailable || !biometricEnabled) {
    return null;
  }

  const biometricName = getBiometricTypeName();

  return (
    <div className="biometric-login-container">
      <button
        type="button"
        onClick={handleBiometricLogin}
        disabled={disabled || loading}
        className="biometric-btn"
        title={`Inloggen met ${biometricName}`}
      >
        {loading ? (
          <span>Verifiëren...</span>
        ) : (
          <span>
            {`Inloggen met ${biometricName}`}
          </span>
        )}
      </button>

      {localError && (
        <div className="biometric-error">
          {localError}
        </div>
      )}

      {error && !localError && (
        <div className="biometric-error">
          {error}
        </div>
      )}
    </div>
  );
}
